import * as actionTypes from './actionTypes'
import store from '../store'


export function getCompleteFormStore() {
    return store.getState();
}

export function validateCompleteFormUS(validate, updateType) {
    let obj = {
        type: actionTypes.VALIDATE_COMPLETE_STORE,
        "store": store.getState(),
        "validate": validate,
        "updateType": updateType
    }
    return dispatch => {
        store.dispatch(obj);
    }
    
}